import styled from "styled-components";
import { colors } from "../../consts";
import WrapperContainer from "../Containers/WrapperContainer";
import { Paragraph2 } from "../Text/Paragraphs";

export const LogTableWrapper = styled(WrapperContainer)`
  border-radius: 16px;
  border: 1px solid ${colors.RAISIN_20};
  width: 100%;
`;

export const LogTable = styled.table`
  border-collapse: collapse;
  border-style: hidden;

  width: 100%;

  tbody {
    width: 100%;
  }

  tr {
    width: 100%;

    td {
      border: 1px solid ${colors.RAISIN_20};
      width: 100%;
      padding: 8px 16px;

      &:first-of-type {
        width: 30%;
        vertical-align: top;
      }

      ${Paragraph2} {
        color: ${colors.RAISIN_70};
      }
    }
  }
`;

export const AuthorInfo = styled(Paragraph2)`
  line-height: 24px;
  font-weight: 600;
  color: ${colors.RAISIN_100} !important;
`;

export const DateInfo = styled(Paragraph2)`
  font-size: 12px;
  line-height: 18px;

  color: ${colors.RAISIN_80} !important;
`;
